// extracted by mini-css-extract-plugin
module.exports = {"primaryColour":"#09CCC4","section":"Section-module--section--3TIa3","headingWrapper":"Section-module--headingWrapper--l4VoK"};